{
  "daytime": {
    "earlier": "inizio giornata",
    "later": "nel corso della giornata"
  },
  "login": {
    "title": "Login",
    "text": "Login to your account",
    "button": "Login",
    "stressLevel": "Livello di stress",
    "errorDialog": {
      "message": "Errore nome utente o password!",
      "accept": "Ok"
    },
    "placeholder": {
      "username": "Inserire nome utente",
      "password": "Inserire password"
    },
    "passkey": {
      "button": "Login with a passkey"
    }
  },
  "sidebar": {
    "bulletins": "Valanghe.report",
    "dangerSources": "Origini di pericolo",
    "observations": "Osservazioni",
    "incidents": "Incidenti",
    "qfa": "QFA",
    "modelling": "Modelli vari",
    "modellingForecast": "Previsione",
    "modellingZamg": "Multi modelli dello ZAMG ",
    "modellingZamgECMWF": "ZAMG ECMWF-EPS",
    "modellingZamgCLAEF": "ZAMG CLAEF-EPS",
    "modellingZamgMeteogram": "GeoSphere meteogramma",
    "modellingSnowpack": "Modello SNOWPACK",
    "modellingSnowpackMeteo": "Dati meteo simulati SNOWPACK",
    "awsome": "AWSOME",
    "snowpack": "SNOWPACK",
    "geosphere": "GeoSphere",
    "lineaexport": "LINEA",
    "awsstats": "Statistiche servizi valanghe",
    "yearlystats": "Statistiche annuali",
    "graphics": "Grafici",
    "icon": "Meteo"
  },
  "weather": {
    "loading": "Caricamento dei parametri meteorologici e delle immagini in corso...",
    "noPng": "Immagine non trovata.",
    "error": {
      "noParameters": "Non sono disponibili parametri di previsione.",
      "loadFailed": "Impossibile caricare i dati delle previsioni."
    },
    "headings": {
      "model": "Modello",
      "modelRun": "Run del modello",
      "region": "Meteo-nivo zona",
      "parameters": "Parametri",
      "level": "Livello"
    },
    "alt": {
      "fallback": "Mappa delle previsioni",
      "image": "{{model}} {{parameter}}{{level}} {{region}} {{date}} {{hour}}Z"
    },
    "models": {
      "icon": "ICON",
      "gfs": "GFS"
    },
    "regions": {
      "atlantic": "Atlantico",
      "europe": "Europa",
      "alps": "Alpi",
      "euregio": "EUREGIO"
    },
    "levels": {
      "surface": "Superficie",
      "cloudTotal": "Totale",
      "cloudHigh": "Alto",
      "cloudMid": "Medio",
      "cloudLow": "Basso"
    },
    "tooltips": {
      "levelApproxElevation": "Quota approssimativa: ~{{height}} m"
    },
    "parameters": {
      "gfs": {
        "equivalentPotentialTemp": "Temp. equivalente potenziale",
        "relativeHumidity": "Umidità relativa",
        "geopotentialAndIsotachs": "Geopotenziale e isotache",
        "precipitation": "Precipitazione",
        "cape": "CAPE"
      },
      "icon": {
        "cloudCover": "Copertura nuvolosa",
        "ns": "Precipitazione 1h",
        "ns24": "Precipitazione 24h",
        "nsacc": "Precipitazioni accumulate",
        "nsprob24gt20": "Precip. propbab. > 20 mm / 24h",
        "nsprob24gt40": "Precip. propbab. > 40 mm / 24h",
        "nsprob24gt80": "Precip. propbab. > 80 mm / 24h",
        "d2m": "Punto di rugiada 2m",
        "gust": "Raffica di vento max. 10m",
        "cape": "MU-CAPE"
      }
    }
  },
  "menu": {
    "logout": "Logout",
    "language": "Lingue",
    "en": "Inglese",
    "de": "Tedesco",
    "fr": "Francese",
    "it": "Italiano",
    "es": "Spagnolo",
    "ca": "Catalano",
    "oc": "Aranese",
    "fullscreen": "A schermo pieno",
    "settings": "Impostazioni",
    "statistics": "Statistiche",
    "admin": "Admin",
    "region": "Meteo-nivo zona",
    "education": "Formazione"
  },
  "matrix": {
    "label": {
      "snowpackStability": "Stabilità del manto nevoso",
      "frequency": "Frequenza",
      "avalancheSize": "Dimensione valanga",
      "dangerRating": "Grado del pericolo",
      "override": "(modifica valutazione grado del pericolo)",
      "matrix": "Matrice",
      "referToFairStability": "Fare riferimento alla classe \"Discreta\"",
      "referToPoorStability": "Fare riferimento alla classe \"Scarsa\"",
      "dangerLevel1": "Grado di pericolo 1 (debole)"
    }
  },
  "dangerSources": {
    "status": {
      "missing": "manca",
      "available": "disponibile",
      "forecast": "previsione",
      "analysis": "analisi",
      "loading": "Caricamento origini di pericolo ...",
      "saveError": "L'origine di pericolo non poteva essere salvata!",
      "loadDangerSourcesError": "L'origine di pericolo non può essere caricato!",
      "loadVariantsError": "Le varianti dell'origine di pericolo non può essere caricato!",
      "noTitle": "<no title>"
    },
    "variantStatus": {
      "active": "attivo",
      "dormant": "quiescente",
      "inactive": "inattivo"
    },
    "tooltip": {
      "read": "Leggi origine di pericolo",
      "edit": "Modifica l'origine di pericolo"
    },
    "table": {
      "loadMore": "Carica {{count}} più giorni",
      "title": {
        "forecast": "Previsione",
        "analysis": "Analisi"
      }
    },
    "create": {
      "variantStatus": "Status",
      "variantEditable": "Questa variante può essere modificata.",
      "variantNotEditable": "Questa variante non può essere modificata.",
      "uploadError": "The variant could not be loaded from the file.",
      "noVariantsForSelectedDay": "Non sono state definite varianti per questa data.",
      "tooltip": {
        "editDangerSource": "Modifica l'origine di pericolo",
        "loadVariants": "Carica le varianti del giorno precedente",
        "loadVariantsFromForecast": "Carica le varianti dalla previsione",
        "showVariantsOnMap": "Mostrare varianti sulla mappa",
        "edit": "Modifica le micro zone",
        "copy": "Copia variante",
        "download": "Download variant as JSON",
        "upload": "Load variant from JSON",
        "delete": "elimina la variante",
        "compare": "paragona le varianti",
        "forecast": "paragona con la previsione"
      },
      "createDangerSource": "crea un'origine di pericolo",
      "createVariant": "crea una nuova variante",
      "noDangerSources": "nessuna origine di pericolo",
      "title": {
        "slab": "Lastrone",
        "weakLayer": "Strato debole",
        "loose": "Neve a debole coesione",
        "glide": "Valanghe di slittamento",
        "matrix": "Matrice",
        "characteristics": "Caratteristiche",
        "comment": "Commento",
        "uncertainties": "Incertezze"
      },
      "label": {
        "glidingSnowActivity": "Attività di slittamento",
        "snowHeight": "Altezza neve",
        "snowHeightLowerLimit": "Altezza minima neve ",
        "snowHeightUpperLimit": "Altezza massima neve",
        "snowHeightAverage": "Altezza media neve",
        "zeroDegreeIsotherm": "Isoterma a 0°C",
        "looseSnowMoisture": "Umidità neve a debole coesione",
        "looseSnowGrainShape": "Tipologia grani neve a debole coesione",
        "slabGrainShape": "Tipologia grani lastrone",
        "slabThickness": "Spessore lastrone",
        "slabThicknessLowerLimit": "Spessore minimo lastrone ",
        "slabThicknessUpperLimit": "Spessore massimo lastrone",
        "slabHandHardness": "Durezza mano lastrone",
        "slabHandHardnessLowerLimit": "Durezza mano minima lastrone",
        "slabHandHardnessUpperLimit": "Durezza mano massima lastrone",
        "slabHardnessProfile": "Durezza lastrone",
        "slabEnergyTransferPotential": "Potenzialità del lastrone di supportare la propagazione",
        "slabDistribution": "Distribuzione del lastrone",
        "weakLayerGrainShape": "Tipologia grani dello strato debole",
        "weakLayerGrainShapes": "Tipologia grani dello strato debole",
        "weakLayerGrainSize": "Dimensione grani dello strato debole",
        "weakLayerGrainSizeLowerLimit": "Dimensione minima grani dello strato debole",
        "weakLayerGrainSizeUpperLimit": "Dimensione massima grani dello strato debole",
        "weakLayerPersistent": "Persistenza dello strato debole",
        "weakLayerThickness": "Spessore dello strato debole",
        "weakLayerStrength": "Resistenza al taglio strato debole",
        "weakLayerWet": "Umidità dello strato debole",
        "weakLayerCrustAbove": "Crosta al di sopra dello strato debole",
        "weakLayerCrustBelow": "Crosta al di sotto dello strato debole",
        "weakLayerPosition": "Posizione dello strato debole nel manto nevoso",
        "weakLayerCreation": "Formazione di uno strato debole",
        "weakLayerDistribution": "Distribuzione dello strato debole",
        "dangerSpotRecognizability": "Riconoscibilità dei punti pericolosi",
        "remoteTriggering": "Distacco a distanza",
        "hasDaytimeDependency": "Dipendenza diurna",
        "dangerIncreaseWithElevation": "Pericolo aumenta con la quota",
        "runoutIntoGreen": "Valanghe arrivano fino ai prati",
        "penetrateDeepLayers": "Penetrare fino agli strati profondi",
        "highestDangerAspect": "Esposizione con il grado di pericolo più elevato",
        "dangerPeak": "Picco del pericolo",
        "slopeGradient": "Inclinazione del pendio",
        "naturalRelease": "Distacco spontaneo",
        "terrainTypes": "Tipo di terreno",
        "dangerSigns": "Segnali d'allarme",
        "aspects": "Esposizioni"
      },
      "createDangerSourceDialog": {
        "title": "Titolo",
        "description": "Descrizione",
        "save": "Salva",
        "cancel": "Cancella"
      },
      "editDangerSourceDialog": {
        "title": "Titolo",
        "description": "Descrizione",
        "update": "Aggiornamento",
        "cancel": "Cancella"
      },
      "deleteVariantDialog": {
        "message": "Vuoi cancellare questa variante?",
        "accept": "Sì",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "Almeno una micro zona deve appartenere alla tua Provincia.",
        "accept": "Ok"
      },
      "discardDialog": {
        "message": "Vuoi scartare le modifiche?",
        "accept": "Sì",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "Si è verificato un errore nel salvataggio delle origini di pericolo!",
        "accept": "Ok"
      },
      "loadDialog": {
        "message": "Vuoi caricare tutte le varianti delle origini di pericolo relative al giorno precedente?<br><strong>Le varianti di analisi esistenti verranno sovrascritte.</strong>",
        "accept": "Sì",
        "reject": "No"
      },
      "loadFromForecastDialog": {
        "message": "Vuoi caricare tutte le varianti dalla previsione?<br><strong>Le varianti di analisi esistenti verranno sovrascritte.</strong>",
        "accept": "Sì",
        "reject": "No"
      }
    }
  },
  "avalancheType": {
    "title": "Tipo di valanga",
    "slab": "lastrone",
    "loose": "a debole coesione",
    "glide": "slittamento",
    "cornice": "cornice",
    "unknown": "sconosciuto",
    "label": {
      "slab": "LASTRONE",
      "loose": "A DEBOLE COESIONE",
      "glide": "SLITTAMENTO"
    },
    "tooltip": {
      "slab": "Valanga di neve a lastroni",
      "loose": "Valanga di neve a debole coesione",
      "glide": "Valanga di slittamento"
    }
  },
  "elevation": {
    "title": "Quota",
    "high": "al di sotto",
    "low": "al di sopra",
    "treeline": "Limite del bosco"
  },
  "bulletins": {
    "title": "Valanghe.report",
    "tooltip": {
      "edit": "Modifica bollettino",
      "read": "Leggi bollettino",
      "copy": "Copia bollettino valanghe",
      "paste": "Incolla bollettino valanghe",
      "cancel": "Annulla la copia",
      "update": "Modifica",
      "submit": "Invia",
      "submitUpdate": "Invia update",
      "publishChange": "Pubblica ora (senza messaggi)",
      "publishUpdate": "Pubblica ora",
      "publishMinimal": "Pubblicazione minima",
      "caaml": "Mostra CAAML",
      "json": "Mostra JSON",
      "create": "Crea bollettino valanghe",
      "preview": "Anteprima del bollettino valanghe (PDF)",
      "check": "Controlla bollettino valanghe",
      "info": "Mostra lo stato pubblicazione",
      "loadSuggestionFromDangerSources": "Carica proposta dalle origini di pericolo",
      "deleteAllWarningRegions": "Elimina tutte le meteo-nivo zone",
      "publishAll": "Pubblica tutte le meteo-nivo zone",
      "publishAllNoMessages": "Pubblica tutte le meteo-nivo zone (senza messaggi)",
      "mediaFile": "Carica file media",
      "publicationChecklist": "Apri lista di controllo per la pubblicazione"
    },
    "publicationChecklist": {
      "title": "Lista di controllo per la pubblicazione",
      "description": {
        "website": "La mappa sul sito web mostra i gradi di pericolo con i relativi colori. Cliccando su una meteo-nivo zona vengono visualizzati i problemi valanghivi e i relativi testi.",
        "email": "È stata inviata un'e-mail che contiene il bollettino.",
        "telegram": "È stato pubblicato un messaggio che contiene un link al sito web.",
        "whatsapp": "È stato pubblicato un messaggio che contiene un link al sito web."
      },
      "ok": "Ok",
      "problem": "Problema",
      "problemDescription": "Descrizione del problema",
      "problemPlaceholder": "Descrivi il problema che hai notato",
      "channel": {
        "website": "Sito web",
        "whatsapp": "WhatsApp",
        "telegram": "Telegram",
        "email": "Email"
      },
      "publicationInProgress": "Pubblicazione in corso",
      "publicationFinishedOnServer": "Pubblicazione completata sul server",
      "publishDisabled": {
        "inProgress": "La pubblicazione è attualmente in corso.",
        "wrongStatus": "Il bollettino deve essere inviato o pubblicato."
      },
      "emailWaitHint": "La distribuzione delle e-mail richiede solitamente più tempo rispetto ai messaggi sui social media. Prima di passare alla fase successiva, dovresti attendere almeno 5 minuti dalla pubblicazione.",
      "email": {
        "waitTitle": "Aspetta:"
      },
      "options": "Opzioni",
      "republish": "Ripubblica:",
      "resend": "Invia nuovamente:",
      "website": {
        "checkInternetTitle": "Verifica la connessione a Internet:",
        "checkInternetDescriptionPrefix": "Com'è la connessione a Internet sul tuo dispositivo? Apri",
        "checkInternetDescriptionSuffix": "in una finestra separata. Il bollettino di ieri viene visualizzato correttamente?",
        "republishHint": "Esegui questo step solo se l'operazione “Verifica connessione Internet” è risultata positiva e sono trascorsi almeno 5 minuti dall'ultimo tentativo di pubblicazione.",
        "publishMinimalTitle": "Pubblicazione minima",
        "publishMinimalHint": "Utilizza questa opzione solo come soluzione alternativa qualora la pubblicazione completa non andasse a buon fine. Pubblica solo dati CAAML — nessuna mappa, text-to-speech o messaggi push. ⚠️ Influisce anche altre regioni su questo server, non solo la vostra. Tutte le pubblicazioni verranno ripubblicate in modalità minima.",
        "editAndResendTitle": "Modifica e invia nuovamente:",
        "openBulletin": "Apri il bollettino",
        "clickEdit": "Clicca su \"Modifica\"",
        "clickSubmit": "Clicca su \"Invia\"",
        "clickPublishNow": "Clicca su \"Pubblica ora\""
      },
      "manualSend": {
        "title": "Invio manuale:",
        "description": {
          "telegram": "Copia il testo qui sotto e invialo al gruppo Telegram indicato.",
          "whatsapp": "Copia il testo qui sotto nel canale WhatsApp indicato."
        },
        "copyText": "Copia {{language}} {{channel}} testo"
      },
      "newChecklist": "Nuova lista di controllo",
      "savedInfo": "Salvato da {{user}}, {{time}}",
      "print": {
        "contact": {
          "title": "Contatto in caso di emergenza",
          "emailLabel": "E-mail:",
          "nameLabel": "Nome:",
          "phoneLabel": "Telefono:"
        },
        "emergencyTitle": "In caso di gravi problemi",
        "fallback": {
          "title": "Usa un’istanza di fallback:",
          "step1": "Vai all'instanza di fallback dell'Admin-GUI e pubblica lì il bollettino.",
          "step2": "Invia manualmente messaggi ai canali sottoscritti. Utilizza il testo seguente:",
          "step3": "Informa il pubblico creando post sui social media con un collegamento all'URL del sito web di fallback.",
          "step4": "Informa l'ufficio relazioni pubbliche (PR) della situazione."
        },
        "hide": "Nascondi versione stampabile",
        "hint": "Inserisci di seguito i recapiti del servizio di hosting e gli URL del sito web di fallback, quindi fare clic su \"Stampa\".",
        "hostingDescription": "Chiedi informazioni sullo stato del server. Se necessario, richiedi il riavvio del server.",
        "hostingTitle": "Contatta il servizio di hosting:",
        "print": "Stampa",
        "toggle": "Versione stampabile"
      }
    },
    "status": {
      "submittedInfo": "Verrà pubblicato alle 17:00",
      "resubmittedInfo": "Verrà pubblicato alle 08:00",
      "publishedInfo": "È stato pubblicato",
      "noPublicationInfo": "NON verrà pubblicato automaticamente",
      "loadingPreview": "Creare un'anteprima in PDF ...",
      "loading": "Carica bollettino ...",
      "loadMoreBulletins": "Carica {{count}} più bollettini",
      "publishing": "Pubblica bollettino ...",
      "submitting": "Invia bollettino ...",
      "saveError": "Non é stato possibile salvare il bollettino!",
      "loadBulletinsError": "Non é stato possibile caricare il bollettino!"
    },
    "create": {
      "tooltip": {
        "edit": "Modifica le micro zone",
        "copy": "Copia meteo-nivo zona",
        "delete": "Elimina  meteo-nivo zona",
        "deleteProblem": "Cancella problema valanghivo",
        "compare": "Confronta meteo-nivo zona",
        "undo": "Annulla l'ultima modifica apportata alla meteo-nivo zona",
        "redo": "Ripeti l'ultima modifica nella meteo-nivo zona",
        "createRegion": "Crea meteo-nivo zona",
        "cancel": "Cancella",
        "acceptSuggestion": "Accetta meteo-nivo zone suggerite",
        "rejectSuggestion": "Scarta meteo-nivo zone suggerite",
        "saveChanges": "Salva modifiche",
        "discardChanges": "Scarta modifiche",
        "incompleteAvalancheProblem": "Problema valanghivo incompleto",
        "saveBulletin": "Salva bollettino valanghe",
        "discardBulletin": "Scarta modifiche del bollettino valanghe",
        "loadBulletin": "Copia il bollettino valanghe del giorno precedente",
        "uploadCaamlBulletin": "Carica il bollettino valanghe in formato CAAML",
        "uploadJsonBulletin": "Carica il bollettino valanghe in formato JSON",
        "downloadCaamlBulletin": "Scarica il bollettino valanghe in formato CAAML",
        "downloadJsonBulletin": "Scarica il bollettino valanghe in formato JSON",
        "daytimeDependency": "Dipendenza diurna",
        "treeline": "Limite del bosco",
        "tendency": {
          "decreasing": "Pericolo valanghe in diminuazione",
          "steady": "Pericolo valanghe stabile",
          "increasing": "Pericolo valanghe in aumento",
          "danger": "Pericolo valanghe"
        },
        "textcat": {
          "edit": "Modifica",
          "copy": "Copia",
          "paste": "Incolla",
          "example": "Carica testo campione",
          "delete": "Elimina"
        },
        "moveUpAvalancheProblem": "Sposta problema valanghivo verso l'alto",
        "moveDownAvalancheProblem": "Sposta problema valanghivo verso il basso",
        "dangerRatingDirectionUp": "Verso l'alto",
        "dangerRatingDirectionDown": "Verso il basso",
        "addPhoto": "Aggiungi foto",
        "removePhoto": "Elimina foto",
        "uploadPhoto": "Carica foto",
        "editPhoto": "Modifica foto"
      },
      "save": " Salva",
      "discard": " Scarta",
      "back": " Indietro",
      "createAggregatedRegion": " Nuova meteo-nivo zona",
      "pasteAggregatedRegion": "Incolla meteo-nivo zona",
      "pendingSuggestions": "Proposte",
      "rejectSuggestion": "Rifiuta",
      "acceptSuggestion": "Accetta",
      "cancelCopyBulletin": "Cancella",
      "createAvalancheProblem": "Nuovo problema valanghivo",
      "ownRegions": "Proprie meteo-nivo zone",
      "foreignRegions": "Altre meteo-nivo zone",
      "externalRegions": "Meteo-nivo zone esterne",
      "mapSelectRegion": "Seleziona micro-zone sulla mappa",
      "statusHeader": "Stato del bollettino",
      "suggestions": "Proposte",
      "noBulletinsForSelectedDay": "Nessuna meteo-nivo zona definita per questa data.",
      "autosave": "Salvato automaticamente",
      "regionEditable": "Questa meteo-nivo zona può essere modificata.",
      "regionNotEditable": "Questa meteo-nivo zona non può essere modificata.",
      "regionLocked": "Questa meteo-nivo zona è bloccata.",
      "changeDangerRatingElevation": "Estendi il grado di pericolo valanghe",
      "mapTop": "Mappa in alto",
      "mapLeft": "Mappa a lato",
      "showExternalRegions": "Mostra meteo-nivo zone esterne",
      "hideExternalRegions": "Nascondi meteo-nivo zone esterne",
      "showNotes": "Mostra gli appunti",
      "hideNotes": "Nascondi gli appunti",
      "incompleteAvalancheProblem": "Incompleto",
      "label": {
        "generalHeadlineComment": "Titolo generale",
        "importantObservations": "Osservazioni importanti",
        "avalancheProblems": "Problema valanghivo",
        "aspects": "Esposizione",
        "highlights": "Allerta speciale",
        "avActivityHighlights": "Titolo situazione pericolo valanghe",
        "avActivityComment": "Descrizione pericolo valanghe",
        "travelAdvisoryHighlights": "Titolo consigli su itinerari e gestione terreno",
        "travelAdvisoryComment": "Descrizione consigli su itinerari e gestione terreno",
        "snowpackStructureHighlights": "Titolo struttura manto nevoso",
        "snowpackStructureComment": "Descrizione struttura manto nevoso",
        "dangerPatterns": "Situazioni tipo",
        "tendencyComment": "Descrizione della tendenza",
        "synopsisHighlights": "Titolo panoramica meteo",
        "synopsisComment": "Panoramica meteo",
        "notes": "Commenti",
        "noSnow": "Senza neve"
      },
      "copyRegion": {
        "label": "Copia la meteo-nivo zona in un altro bollettino",
        "select": "Incolla in ...",
        "currentBulletin": "Questo bollettino"
      },
      "title": {
        "avalancheProblem": "Problemi valanghivi",
        "dangerDescription": "Descrizione pericolo valanghe",
        "forenoon": "Mattina",
        "afternoon": "Pomeriggio",
        "photos": "Foto",
        "snowpackStructure": "Struttura manto nevoso",
        "tendency": "Tendenza",
        "synopsis": "Meteo",
        "travelAdvisory": "Travel advisory",
        "showTranslations": " Mostra traduzione",
        "hideTranslations": " Nascondi traduzione"
      },
      "photos": {
        "url": "URL Foto",
        "locationName": "Località",
        "microregion": "Micro zona",
        "copyright": "Copyright",
        "date": "Data"
      },
      "placeholder": {
        "notes": "Scrivi tuo commenti qui..."
      },
      "pmDialog": {
        "noIFrameSupport": "Il tuo browser non supporta IFrames!"
      },
      "discardDialog": {
        "message": "Vuoi scartare le modifiche?",
        "accept": "Sí",
        "reject": "No"
      },
      "deleteAggregatedRegionDialog": {
        "message": "Vuoi cancellare la meteo-nivo zona?",
        "accept": "Sí",
        "reject": "No"
      },
      "noRegionDialog": {
        "message": "Almeno una micro zona deve appartenere alla tua Provincia.",
        "accept": "Ok"
      },
      "loadDialog": {
        "message": "Vuoi caricare i bollettini del giorno precedente?<br><strong>Questa scelta eliminerà tutte le meteo-nivo zone esistenti!</strong>",
        "accept": "Sí",
        "reject": "No"
      },
      "deleteAllWarningRegionsDialog": {
        "message": "Vuoi cancellare tutte le meteo-nivo zone?",
        "accept": "Sì",
        "reject": "No"
      },
      "loadSuggestionsFromDangerSourcesDialog": {
        "message": "Vuoi caricare i risultati provenienti dalla origini di pericolo?<br><strong>Questa scelta eliminerà tutte le meteo-nivo zone esistenti!</strong>",
        "accept": "Sì",
        "reject": "No"
      },
      "loadAutoSaveDialog": {
        "message": "Vuoi caricare il bollettino valanghe salvato automaticamente?",
        "accept": "Sí",
        "reject": "No"
      },
      "saveErrorDialog": {
        "message": "Errore salvando il bollettino valanghe!",
        "accept": "Ok"
      },
      "changeErrorDialog": {
        "message": "Errore durante la modificazione del bollettino valanghe!",
        "accept": "Ok"
      },
      "loadingErrorDialog": {
        "message": "Errore durante il caricamento del bollettino valanghe!",
        "accept": "Ok"
      },
      "loadingJsonFileErrorDialog": {
        "message": "C'è stato un errore nel caricamento dei bollettini dal file JSON!",
        "accept": "Ok"
      },
      "avalancheProblemErrorDialog": {
        "message": "Manca il problema tipico valanghivo, l'esposizione, la stabilità del manto nevoso, la frequenza e/o la dimensione valanghe per almeno un problema valanghivo",
        "accept": "Ok"
      },
      "loadAvActivityCommentExampleTextDialog": {
        "message": "Per quale situazione vuoi caricare il testo?",
        "newSnow": "Neve fresca",
        "windSlab": "Lastroni da vento",
        "persistentWeakLayers": "Strati deboli persistenti",
        "wetSnow": "Neve bagnata",
        "glidingSnow": "Valanghe di slittamento",
        "favourableSituation": "Situazione favorevole",
        "cancel": "Cancella"
      },
      "removeDaytimeDependencyDialog": {
        "message": "Quali problemi valanghivi vuoi mantenere?",
        "cancel": "Cancella"
      },
      "strategicMindsetDialog": {
        "title": "Strategic Mindsets",
        "introduction": "Gli “Strategic Mindsets” sono intesi come espressione del nostro atteggiamento mentale nei confronti della situazione valanghiva e del suo sviluppo nella meteo-nivo zona corrispondente. Non dovrebbero derivare direttamente dalla valutazione del pericolo, ma piuttosto essere compresi e utilizzati come un'impressione intuitiva della situazione generale. I “Strategic Mindsets” sono quindi principalmente uno strumento di comunicazione. Utilizzando i mindset e le definizioni associate, noi previsori possiamo scambiare in modo rapido ed efficiente informazioni sullo sviluppo della situazione di pericolo e trovare un linguaggio comune per la comunicazione.",
        "description": {
          "title": "Descrizione:",
          "text": {
            "assessment": "C'è una <b>grande incertezza</b> nella valutazione del pericolo a causa delle<b>informazioni insufficienti</b> raccolte sul terreno.",
            "stepping_out": "<b>Tendenza alla diminuzione</b> della situazione di pericolo (anche all'interno dello stesso grado di pericolo).",
            "status_quo": "Stessa situazione di pericolo.<b>Nessun cambiamento significativo</b> rispetto al giorno precedente.",
            "stepping_back": "<b>Tendenza all'aumento</b> della situazione di pericolo (anche all'interno dello stesso grado di pericolo).",
            "entrenchment": "<b>Situazione di pericolo quasi costante e tesa.</b> Il pericolo principale deriva da (a) <b>uno strato debole persistente</b>(s) suscettibile al distacco.",
            "free_ride": "<b>Debole pericolo di valanghe</b> con un manto nevoso generalmente stabile. Sono possibili solo valanghe di dimensioni piccole nei terreni estremamente ripidi. ",
            "high_alert": "Situazione eccezionale con <b>pericolo di valanghe forte o molto forte</b>. Sono possibili valanghe spontanee di <b>dimensioni molto grandi o estreme </b>",
            "spring_diurnal": "Determinanti per la valutazione del rischio sono valanghe di neve umida nel corso della giornata che sono soggetti ad un <b>cicolo diurno chiaro</b>."
          }
        },
        "communication": {
          "title": "Comunicazione",
          "text": {
            "assessment": "La situazione valanghiva deve essere verificata a livello locale. Un comportamento prudente è opportuno.",
            "stepping_out": "Graduale diminuzione del pericolo. Tuttavia, occorre ancora prudenza e valutare localmente il miglioramento della situazione prima di addentrarsi in terreni più rischiosi. ",
            "status_quo": "La situazione di pericolo è invariata. Il riscontro degli osservatori aiuta a delineare meglio la situazione di pericolo. I terreni più favorevoli devono essere comunicati e messi in evidenza.",
            "stepping_back": "Comunicazione chiara dell'aumento del pericolo di valanghe, anche all'interno di un grado di pericolo. Informazioni sulle cause supportano la comprensibilità della comunicazione.",
            "entrenchment": "Sono necessarie cautela e moderazione. È difficile che la situazione cambi. Se possibile, fornire informazioni il più possibile precise sulla distribuzione e sulla suscettibilità al distacco. Maggiore comunicazione delle osservazioni che rendono evidente la situazione e inducono alla un comportamento prudente.",
            "free_ride": "Poco testo. Sottolineare la situazione generale favorevole e le zone di pericolo potenzialmente isolate.",
            "high_alert": "Comunicazione su tutti i canali. L'attenzione non è più rivolta agli sport invernali. Pericolo anche in aree solitamente non a rischio di valanghe.",
            "spring_diurnal": "Situazione favorevole al mattino, pericolo in aumento durante il giorno. La valutazione va fatta localmente osservando l'ammorbidimento della crosta da fusione e rigelo e la crescente umidificazione del manto nevoso."
          }
        },
        "examples": {
          "title": "Esempi:",
          "text": {
            "assessment": "Inizio stagione.",
            "stepping_out": "Un raffreddamento porta a una diminuzione del pericolo di valanghe di neve bagnata dopo una fase di tempo caldo e umido.",
            "status_quo": "Problema persistente di lastroni da vento con temperature fredde, neve a debole coesione e vento.",
            "stepping_back": "Nevicate abbondanti portano a un aumento della situazione di pericolo.",
            "entrenchment": "Problema critico di strati deboli persistenti con potenziale per valanghe pericolosamente grandi. La situazione si sta stabilizzando solo molto lentamente e richiede molta prudenza.",
            "free_ride": "Pericolo di valanghe debole, assenza di strati deboli persistenti, tutti i pendii sono già stati tracciati.",
            "high_alert": "Grado di pericolo 4 o superiore a causa di grandi quantità di neve fresca e/o strati deboli problematici e persistenti. ",
            "spring_diurnal": "Situazione primaverile con tempo secco e alta pressione e temperature moderate con un manto nevoso vecchio per lo più stabile."
          }
        },
        "strategicMindset": {
          "assessment": "Incertezza elevata",
          "stepping_out": "Miglioramento",
          "status_quo": "Status quo",
          "stepping_back": "Decelerazione",
          "entrenchment": "Persistente instabile",
          "free_ride": "Favorevole",
          "high_alert": "Massima allerta",
          "spring_diurnal": "Situazione primaverile"
        }
      },
      "decisionTree": {
        "filepath": "./assets/img/decision_tree-it.svg",
        "decisionTree": "Albero decisionale",
        "save": "Salva",
        "discard": "Scarta"
      }
    },
    "table": {
      "title": {
        "date": "Data"
      },
      "status": {
        "missing": "manca",
        "draft": "bozza",
        "submitted": "inviato",
        "published": "pubblicato",
        "updated": "aggiornato",
        "resubmitted": "versione aggiornata inviata",
        "republished": "versione aggiornata pubblicata"
      },
      "publishBulletinsDialog": {
        "message": "Vuoi pubblicare il bollettino valanghe?"
      },
      "publicationStatusDialog": {
        "headline": "Stato della pubblicazione",
        "publishedBy": "Pubblicato da: ",
        "publishedAt": "Pubblicato alle: ",
        "validFor": "Valido per: ",
        "title": {
          "prod": "Cose serie",
          "test": "Test system",
          "task": "Attività",
          "language": {
            "all": "TUTTO",
            "de": "DE",
            "it": "IT",
            "en": "EN"
          }
        },
        "email": {
          "label": "Email",
          "tooltip": "Inviare Email",
          "success": "Email inviati con successo!",
          "error": "Non è stato possibile inviare e-mail"
        },
        "telegram": {
          "label": "Messagio Telegram",
          "tooltip": "Invia messaggio via Telegram",
          "success": "Messaggi via Telegram inviati con successo!",
          "error": "Messaggi di Telegram non possono essere inviati!"
        },
        "whatsapp": {
          "label": "Messagio WhatsApp",
          "tooltip": "Invia messaggi WhatsApp",
          "success": "Messaggi via WhatsApp inviati con successo!",
          "error": "Messaggi WhatsApp non possono essere inviati!"
        },
        "push": {
          "label": "Notifica push",
          "tooltip": "Invia notifica push",
          "success": "Notifiche push inviate con successo!",
          "error": "Non è stato possibile inviare le notifiche push!"
        },
        "accept": "Ok",
        "confirm": "Voi inviare al {{channel}} ({{language}})?"
      },
      "mediaFileDialog": {
        "headline": "File media",
        "important": "IMPORTANTE",
        "missingFile": "Nessun file selezionato!",
        "uploadError": "Upload fallito!",
        "accept": "Invia",
        "reject": "Cancella"
      },
      "publishBulletinsErrorDialog": {
        "message": "Errore pubblicando il bollettino valanghe!",
        "accept": "Ok"
      },
      "submitBulletinsDialog": {
        "message": "Vuoi inviare il bollettino valanghe?"
      },
      "submitBulletinsErrorDialog": {
        "message": "Errore durante l'invio del bollettino valanghe!",
        "accept": "Ok"
      },
      "submitBulletinsDuplicateRegionDialog": {
        "message": "Meteo-nivo zone valutate più volte! Non è possibile inviare il bollettino valanghe.",
        "accept": "Ok"
      },
      "checkBulletinsErrorDialog": {
        "message": "Errore verficando il bollettino valanghe!",
        "accept": "Ok"
      },
      "previewErrorDialog": {
        "message": "L'anteprima non può essere caricata!",
        "accept": "Ok"
      },
      "checkBulletinsDialog": {
        "message": "Controllare bollettino valanghe",
        "ok": "(tutto va bene)"
      },
      "publishAllDialog": {
        "message": "Vuoi pubblicare tutte le meteo-nivo zone?",
        "changeMessage": "Vuoi pubblicare tutte le meteo-nivo zone? (senza messaggi)"
      },
      "bulletinCheck": {
        "missingDangerRating": "Grado di pericolo non definito",
        "missingDangerRatingModificator": "Modificatore del grado di pericolo non selezionato",
        "missingRegion": "Meteo-nivo zone non valutate",
        "duplicateRegion": "Meteo-nivo zone valutate più volte",
        "missingAvActivityHighlights": "Manca titolo situazione di pericolo",
        "missingAvActivityComment": "Manca valutazione pericolo valanghe",
        "missingSnowpackStructureHighlights": "Manca il titolo della descrizione della struttura del manto nevoso",
        "missingSnowpackStructureComment": "Manca la descrizione della struttura del manto nevoso",
        "pendingSuggestions": "Proposta non confermata",
        "incompleteTranslation": "Traduzione incompleta"
      }
    }
  },
  "training": {
    "training": "Training",
    "timestamp": "Momento del training"
  },
  "admin": {
    "loadingStatistics": "Creazione CSV ...",
    "server-configuration": {
      "title": "Server",
      "button": {
        "create": "Crea server",
        "save": "Salva"
      },
      "table": {
        "name": "Nome",
        "userName": "Nome utente",
        "password": "Password",
        "publishAt5PM": "Pubblica alle 17:00",
        "publishAt8AM": "Pubblica alle 08:00",
        "pdfDirectory": "Cartella per PDF",
        "htmlDirectory": "Cartella per HTML",
        "serverImagesUrl": "Path alle immagini sul server",
        "dangerLevelElevationDependency": "Dipendenza di quota del grado di pericolo ",
        "mapsPath": "Path alle mappe",
        "mediaPath": "Path ai file media",
        "mapProductionUrl": "URL per la produzione di mappe",
        "apiUrl": "API URL"
      },
      "success": "Configurazione salvata con successo",
      "error": "Non é stato possibile salvare le configurazione"
    },
    "region-configuration": {
      "title": "Meteo-nivo zona",
      "button": {
        "create": "Crea meteo-nivo zona",
        "save": "Salva"
      },
      "table": {
        "general": {
          "title": "In generale"
        },
        "publication": {
          "title": "Pubblicazione"
        },
        "components": {
          "title": "Componenti"
        },
        "configuration": {
          "title": "Configurazione"
        },
        "languageConfiguration": {
          "title": "Configurazione lingue"
        }
      },
      "success": "Configurazione salvata con successo",
      "error": "Non é stato possibile salvare la configurazione"
    },
    "users": {
      "title": "Utenti",
      "button": {
        "create": "Crea utente"
      },
      "tooltip": {
        "edit": "Modifica utente",
        "changePassword": "Cambia password",
        "delete": "Cancella utente"
      },
      "table": {
        "name": "Nome",
        "email": "Email",
        "organization": "Organizzazione",
        "regions": "Meteo-nivo zone",
        "roles": "Ruoli"
      },
      "deleteUserModalDialog": {
        "message": "Voi cancellare questo utente?",
        "accept": "Sì",
        "reject": "No"
      },
      "deleteUser": {
        "success": "Utente cancellato",
        "error": "L'utente non può essere cancellato"
      },
      "createUser": {
        "success": "Utente creato",
        "error": "L'utente non può essere creato"
      },
      "updateUser": {
        "success": "Utente salvato con successo",
        "error": "Non è stato possibile salvare l’utente"
      }
    },
    "createUser": {
      "table": {
        "image": "Immagine",
        "name": "Nome",
        "email": "Email",
        "organization": "Organizazzione",
        "password": "Password",
        "password2": "Ripeti la password",
        "roles": "Ruoli",
        "regions": "Meteo-nivo zone"
      },
      "error": {
        "name": {
          "required": "Inserire un nome"
        },
        "email": {
          "required": "Inserire un indirizzo email",
          "invalid": "L'indirizzo Email non è valido"
        },
        "password": {
          "required": "Inserisci una password",
          "length": "La password deve essere di almeno 8 caratteri",
          "mismatch": "Le password non corrispondono"
        }
      },
      "button": {
        "create": "Crea utente",
        "update": "Aggiorna utente",
        "cancel": "Cancella"
      }
    },
    "observations": {
      "table": "Tabella",
      "map": "Mappa",
      "gallery": "Galleria",
      "filters": "Filtri",
      "details": "Dettagli",
      "title": "Osservazioni",
      "newObservation": "Nuova osservazione",
      "exportObservations": "Esporta osservazioni (GeoJSON)",
      "exportStatistics": "Esporta statistiche (CSV)",
      "toggleFilterBar": "Visualizza/nascondi barra dei filtri",
      "button": {
        "submit": "Scarica"
      },
      "label": {
        "dateRange": "Periodo",
        "observer": "Osservatore"
      },
      "selectRegion": {
        "placeholder": "Meteo-nivo zona",
        "selectionLabel": "{0} meteo-nivo zone selezionate"
      },
      "selectSources": {
        "placeholder": "origine dati",
        "selectionLabel": "{0} origine/i selezionato/i"
      },
      "charts": {
        "charts": "Diagrammi",
        "nan": "Senza specificazione",
        "reload": "Ricarica",
        "classify": "Classifica",
        "label": "Denominazione",
        "invert": "Inversione",
        "reset": "Reset",
        "aspect": {
          "caption": "Esposizione"
        },
        "elevation": {
          "caption": "Quota"
        },
        "stability": {
          "caption": "Stabilità"
        },
        "observationType": {
          "caption": "Tipo di osservazione"
        },
        "importantObservation": {
          "caption": "Importante"
        },
        "avalancheProblem": {
          "caption": "Problema valanghivo"
        },
        "dangerPattern": {
          "caption": "Situazione tipo"
        },
        "dangerSource": {
          "caption": "Origini di pericolo"
        },
        "days": {
          "caption": "Giorno"
        }
      }
    },
    "blog": {
      "title": "Blog",
      "language": {
        "title": "Lingua",
        "de": "DE",
        "it": "IT",
        "en": "EN"
      },
      "all": {
        "tooltip": "Invia email, Telegram, WhatsApp e Push",
        "success": "Email, Telegram, WhatsApp e Push inviati con successo!",
        "error": "Non è stato possibile inviare le email, Telegram, WhatApp e Push!"
      },
      "email": {
        "tooltip": "Invia email",
        "success": "Email inviati con successo!",
        "error": "Non è stato possibile inviare email!"
      },
      "telegram": {
        "tooltip": "Pubblicazione via canale Telegram",
        "success": "Messaggi via Telegram inviati con successo!",
        "error": "Messaggi di Telegram non possono essere inviati!"
      },
      "whatsapp": {
        "tooltip": "Invia via canale WhatsApp",
        "success": "WhatsApp inviato con successo!",
        "error": "Non era possibile inviare WhatsApp!"
      },
      "push": {
        "tooltip": "Invia tramite notifiche push",
        "success": "Push inviati con successo!",
        "error": "Non è stato possibile inviare Push!"
      }
    }
  },
  "settings": {
    "title": "Impostazioni",
    "effectiveRole": "Ruolo effettivo",
    "effectiveRoleDefault": "Tutti i ruoli",
    "changePassword": {
      "title": "Cambia password",
      "oldPassword": {
        "label": "Password attuale",
        "placeholder": "Password attuale"
      },
      "newPassword1": {
        "label": "Nuova password",
        "placeholder": "Nuova password"
      },
      "newPassword2": {
        "label": "Nuova password (ripetere)",
        "placeholder": "Nuova password"
      },
      "submit": "Cambia password",
      "passwordChanged": "Password modificata con sucesso",
      "passwordChangeError": "Non é stato possibile cambiare la password",
      "passwordIncorrect": "Password attuale non corretta",
      "error": {
        "oldPassword": {
          "required": "Inserire password attuale"
        },
        "newPassword": {
          "required": "Inserire nuova password",
          "mismatch": "Le password non corrispondono"
        }
      }
    },
    "display": {
      "title": "Mostra",
      "table": {
        "showCaaml": "Mostra CAAML",
        "showJson": "Mostra JSON"
      }
    },
    "passkeys": {
      "title": "Passkeys",
      "unsupported": "Your browser does not support passkeys.",
      "empty": "No passkeys registered yet.",
      "unnamed": "Passkey",
      "lastUsed": "Last used",
      "neverUsed": "Never used",
      "namePlaceholder": "e.g. iPhone, YubiKey",
      "add": "Add passkey",
      "delete": "Delete",
      "added": "Passkey added",
      "addError": "Could not add passkey",
      "deleteError": "Could not delete passkey"
    }
  },
  "statistics": {
    "title": "Statistiche",
    "bulletins": "Bollettini valanghe",
    "dangerSources": "Origini di pericolo",
    "button": {
      "submit": "Scarica"
    },
    "label": {
      "dateRange": "Periodo",
      "extended": "Esteso",
      "duplicates": "Doppioni"
    },
    "error": {
      "downloadFailed": "L'esportazione delle statistiche non è stata scaricata correttamente. Riprova."
    }
  },
  "strategicMindset": {
    "title": "Mindset strategico",
    "assessment": "Elevata incertezza",
    "stepping_out": "Miglioramento",
    "status_quo": "Status quo",
    "stepping_back": "In peggioramento",
    "entrenchment": "Instabile persistente",
    "free_ride": "Favorevole",
    "high_alert": "Massima allerta",
    "spring_diurnal": "Situazione primaverile"
  },
  "observationType": {
    "DrySnowfallLevel": "Limite nevicate asciutte ",
    "TimeSeries": "Serie cronologica",
    "Incident": "Evento valanghivo",
    "Profile": "Profilo stratigrafico",
    "Closure": "Chiusura",
    "Blasting": "Brillamento",
    "Avalanche": "Valanga",
    "Evaluation": "Valutazione",
    "SimpleObservation": "Osservazione semplice",
    "Webcam": "Webcam"
  },
  "importantObservation": {
    "ForBlog": "Per il blog",
    "SurfaceHoar": "Brina di superficie",
    "Graupel": "Neve pallottolare",
    "StabilityTest": "Test di stabilità",
    "IceFormation": "Formazione di ghiaccio",
    "VeryLightNewSnow": "Neve fresca leggerissima"
  },
  "elevationTolerance": {
    "exact": "esatto",
    "50m": "±50m",
    "100m": "±100m",
    "200": "±200m"
  },
  "elevationPeriod": {
    "duringPrecipitationEvent": "Limite delle nevicate asciutte per l’intero evento precipitativo",
    "observationPeriod": "Limite delle nevicate asciutte durante il momento di osservazione"
  },
  "aspect": {
    "N": "N",
    "NE": "NE",
    "E": "E",
    "SE": "SE",
    "S": "S",
    "SW": "SO",
    "W": "O",
    "NW": "NO"
  },
  "role": {
    "SUPERADMIN": "Super Amministratore",
    "ADMIN": "Amministratore",
    "FORECASTER": "Previsore",
    "FOREMAN": "Caposquadra",
    "OBSERVER": "Osservatore"
  },
  "tendency": {
    "decreasing": " Pericolo valanghe in diminuizione",
    "steady": " Pericolo valanghe stabile",
    "increasing": " Pericolo valanghe in aumento"
  },
  "complexity": {
    "easy": "Facile",
    "challenging": "Impegnativo",
    "complex": "Complesso"
  },
  "glidingSnowActivity": {
    "low": "debole",
    "medium": "media",
    "high": "forte"
  },
  "wetness": {
    "dry": "asciutta",
    "moist": "umida",
    "wet": "bagnata"
  },
  "characteristic": {
    "low": "debole",
    "medium": "media",
    "high": "forte",
    "very_high": "molto forte"
  },
  "thickness": {
    "thin": "sottile",
    "thick": "spesso"
  },
  "snowpackPosition": {
    "upper": "superiore",
    "middle": "centrale",
    "lower": "inferiore",
    "ground": "suolo"
  },
  "weakLayerCrust": {
    "no": "no",
    "partly": "in parte",
    "yes": "si"
  },
  "creationProcess": {
    "radiation_recrystallization": "radiazione",
    "diurnal_recrystallization": "diurno",
    "melt_layer_recrystallization": "crosta da fusione",
    "surface_hoar_formation": "brina di superficie"
  },
  "recognizability": {
    "very_easy": "molto facile",
    "easy": "facile",
    "hard": "duro",
    "very_hard": "molto duro"
  },
  "distribution": {
    "isolated": "isolato",
    "specific": "determinato",
    "widespread": "diffuso"
  },
  "probability": {
    "likely": "probabile",
    "possible": "possibile",
    "unlikely": "poco probabile"
  },
  "detailedDaytime": {
    "evening": "sera",
    "first_night_half": "prima metà della notte",
    "second_night_half": "seconda metà della notte",
    "morning": "primo mattino",
    "forenoon": "mattina",
    "afternoon": "pomeriggio"
  },
  "slopeGradient": {
    "moderately_steep": "moderatamente ripido",
    "steep": "ripido",
    "very_steep": "molto ripido",
    "extremely_steep": "estremamente ripido"
  },
  "handHardness": {
    "fist": "F",
    "four_fingers": "4F",
    "one_finger": "1F",
    "pencil": "P",
    "knife": "K",
    "ice": "I"
  },
  "hardnessTendency": {
    "decreasing": "in basso più morbido",
    "steady": "uniforme",
    "increasing": "al di sopra più morbido"
  },
  "terrainType": {
    "gullies_and_bowls": " conche e canaloni ",
    "adjacent_to_ridgelines": "zone in prossimità delle creste",
    "distant_from_ridgelines": "zone lontano dalle creste",
    "in_the_vicinity_of_peaks": " in prossimità delle cime",
    "pass_areas": "zone ai passi",
    "shady_slopes": "pendii ombreggiati",
    "sunny_slopes": "pendii soleggiati",
    "grassy_slopes": "pendii erbosi",
    "cut_slopes": "scarpate",
    "wind_loaded_slopes": "pendii carichi di neve ventata",
    "base_of_rock_walls": "basi di pareti rocciose",
    "behind_abrupt_changes_in_the_terrain": "dietro cambi di pendenza",
    "transitions_into_gullies_and_bowls": "passaggi che conducono a conche e canaloni",
    "areas_where_the_snow_cover_is_rather_shallow": "zone scarsamente innevate",
    "transitions_from_a_shallow_to_a_deep_snowpack": "zone di passaggio da poca a molta neve",
    "highly_frequented_off_piste_terrain": "zone fuori pista molto frequentate",
    "little_used_backcountry_terrain": "zone fuori pista poco frequentate",
    "places_that_are_protected_from_the_wind": "zone riparate dal vento",
    "regions_exposed_to_the_foehn_wind": " aree esposte al Föhn",
    "regions_with_a_lot_of_snow": "aree con tanta neve",
    "regions_exposed_to_precipitation": "aree esposte a precipitazioni",
    "regions_exposed_to_heavier_precipitation": " aree più esposte a precipitazioni"
  },
  "dangerSign": {
    "shooting_cracks": "crepe",
    "whumpfing": "rumori \"whumpf\"",
    "fresh_avalanches": "nuove valanghe",
    "glide_cracks": "bocche di balena"
  },
  "changeRegionDialog": {
    "message": "Vuoi cambiare la meteo-nivo zona?",
    "accept": "Sì",
    "reject": "No"
  },
  "zamg": {
    "table": "Tabella",
    "map": "Mappa",
    "region": "Meteo-nivo zona",
    "newSnow": "Neve fresca"
  },
  "snowpack": {
    "plotType": {
      "LWC_stratigraphy": "Neve bagnata: contenuto in acqua",
      "wet_snow_instability": "Neve bagnata: Instabilità neve bagnata",
      "Sk38_stratigraphy": "strati deboli persistenti: Indice stabilità SK38",
      "stratigraphy": "strati deboli persistenti: stratigrafia"
    },
    "aspect": {
      "flat": "piano",
      "north": "Versante nord",
      "south": "Versante sud"
    },
    "meteo": {
      "new_snow_plot_3day": "Neve fresca (3gg)",
      "new_snow_plot_7day": "Neve fresca (7g)",
      "new_snow_plot_1month": "Neve fresca (31g)",
      "new_snow_plot_season": "Neve fresca (stagione)",
      "new_snow_plot_forecast": "Neve fresca (previsione)",
      "wet_snow_plot_3day": "Neve bagnata (3g)",
      "wet_snow_plot_7day": "Neve bagnata (7g)",
      "wet_snow_plot_1month": "Neve bagnata (31g)",
      "wet_snow_plot_season": "Neve bagnata (stagione)",
      "wet_snow_plot_forecast": "Neve bagnata (previsione)",
      "HS_table_24h": "Tabella altezza neve (1g)",
      "HS_table_72h": "Tabella altezza neve (3g)",
      "HS_table_season": "Tabella altezza neve (stagione)",
      "HS_table_forecast": "Tabella altezza neve (previsione)",
      "TA_table_24h": "Tabella temperatura (1g)",
      "TA_table_72h": "Tabella temperatura (3ore)",
      "TA_table_season": "Tabella temperatura (stagione)"
    }
  },
  "grainShape": {
    "PP": {
      "code": "PP",
      "class": "Neve fresca"
    },
    "PPgp": {
      "code": "PPgp",
      "class": "Neve pallottolare"
    },
    "DF": {
      "code": "DF",
      "class": "Cristalli feltrati"
    },
    "RG": {
      "code": "RG",
      "class": "Grani arrotondati"
    },
    "FC": {
      "code": "FC",
      "class": "Cristalli sfaccettati"
    },
    "FCxr": {
      "code": "FCxr",
      "class": "Cristalli sfaccettati, con bordi arrotondati"
    },
    "DH": {
      "code": "DH",
      "class": "Brina di profondità"
    },
    "SH": {
      "code": "SH",
      "class": "Brina di superficie"
    },
    "MF": {
      "code": "MF",
      "class": "Forme da fusione"
    },
    "MM": {
      "code": "MM",
      "class": "Neve artificiale"
    },
    "MFcr": {
      "code": "MFcr",
      "class": "Crosta da fusione e rigelo"
    },
    "IF": {
      "code": "IF",
      "class": "Formazioni di ghiaccio"
    }
  },
  "button": {
    "true": "Sì",
    "false": "No",
    "ok": "Ok",
    "yes": "Sì",
    "no": "No"
  },
  "observations": {
    "$externalURL": "URL esterna (es. al database delle foto)",
    "$type": "Tipo di osservazione",
    "allowEdit": "Modifica osservazione esterna",
    "allowEditTooltip": "Questo impedisce la sovrascrittura di {{ value }}",
    "editIconTooltip": "Osservazione modificata - non viene aggiornato {{ value }}",
    "aspect": "Esposizione",
    "authorName": "Nome dell'autore",
    "avalancheLength": "Lunghezza della valanga",
    "avalancheProblem": "Problema valanghivo",
    "avalancheProblems": "Problema valanghivo",
    "avalancheSize": "Dimensione della valanga",
    "avalancheType": "Tipologia della valanga",
    "avalancheWidth": "Larghezza della valanga",
    "search": "Cerca",
    "count": "# osservazioni",
    "elevationTolerance": "Precisione dei dati di quota",
    "elevationPeriod": "Quota tempo periodo",
    "layers": {
      "observers": "Osservatori",
      "weatherStations": "Stazioni nivometeorologiche automatiche",
      "webcams": "Webcam",
      "observations": "Osservazioni"
    },
    "weatherStations": {
      "tooltips": {
        "drySnowfallLevel": "Limite nevicate asciutte ",
        "globalRadiation": "Radiazione globale",
        "newSnow": "Neve fresca",
        "snowLine": "Limite delle nevicate",
        "snowHeight": "Altezza neve",
        "snowDifference": "Differenza altezza neve",
        "airTemperature": "Temperatura dell'aria",
        "airTemperatureMax": "Temperatura dell'aria max.",
        "airTemperatureMin": "Temperatura dell'aria min.",
        "surfaceTemperature": "Temperatura superficiale",
        "surfaceHoar": "Formazione potenziale di brina di superficie",
        "surfaceHoarCalc": "Formazione potenziale di brina di superficie (Lehning et. al.)",
        "dewPoint": "Temperatura di rugiada",
        "relativeHumidity": "Umidità relativa",
        "windDirection": "Direzione del vento",
        "windSpeed": "Velocità del vento",
        "windGust": "Raffica"
      }
    },
    "webcams": {
      "tooltips": {
        "minusTenMinutes": "10 minuti indietro",
        "minusOneHour": "1 ora indietro",
        "plusTenMinutes": "10 minuti in avanti",
        "plusOneHour": "1 ora in avanti"
      }
    },
    "button": {
      "add": "Aggiungi osservazione",
      "save": "Salva l'osservazione",
      "delete": "Cancella l'osservazione",
      "deleteConfirm": "Cancella l'osservazione?",
      "discard": "Scarta",
      "copyDate": "Copia data evento"
    },
    "comment": "Commento",
    "content": "Contenuto",
    "dangerPatterns": "Situazioni tipo",
    "dangerRating": "Grado pericolo valanghe",
    "dangerSource": "Origini di pericolo",
    "elevation": "Quota",
    "elevationRange": "Fascia altitudinale",
    "elevationLowerBound": "Limite inferiore quota",
    "elevationUpperBound": "Limite superiore quota",
    "eventDate": "Data dell'evento",
    "eventType": "Tipologia dell'evento",
    "eventTypes": {
      "IMPORTANT": "Evento importante",
      "NEIGHBOR_REGION": "Meteo-nivo zona confinante",
      "NORMAL": "Evento normale",
      "PERSON_DEAD": "Evento con persone coinvolte (vittime)",
      "PERSON_INJURED": "Evento con persone coinvolte (feriti)",
      "PERSON_NO": "Evento senza coinvolgimento persone",
      "PERSON_UNINJURED": "Evento che coinvolge persone (non ferite)",
      "PERSON_UNKNOWN": "Evento (sconosciuto)",
      "TRAFFIC": "Traffico"
    },
    "externalURL": "URL esterna (es. al database delle foto)",
    "fractureDepth": "Spessore del lastrone",
    "hasCoordinates": "Contiene coordinate",
    "incline": "Pendenza",
    "importantObservations": "Osservazioni importanti",
    "latitude": "Latitudine",
    "locationName": "Località",
    "longitude": "Longitudine",
    "observationType": "Tipo di osservazione",
    "personInvolvement": "Coinvolgimento di persone",
    "reportDate": "Data del report",
    "showTable": "Tabella",
    "stability": "Stabilità del manto nevoso",
    "withoutCoordinates": "Osservazioni senza coordinate:",
    "sidebar": {
      "filter": {
        "title": "Filtro"
      },
      "legend": {
        "title": "Didascalia"
      },
      "sources": {
        "title": "Fonti dei dati"
      },
      "views": {
        "title": "visualizzazioni"
      }
    }
  },
  "personInvolvement": {
    "Dead": "Evento con persone coinvolte (vittime)",
    "Injured": "Evento con persone coinvolte (feriti)",
    "Yes": "Evento con coinvolgimento di persone",
    "No": "Evento senza coinvolgimento di persone",
    "Uninjured": "Evento con coinvolgimento di persone (non ferite)",
    "Unknown": "Evento (sconosciuto)"
  },
  "units": {
    "cm": "cm",
    "mm": "mm",
    "m": "m"
  },
  "qfa": {
    "day": "Giorno",
    "time": "Ora",
    "back": " Indietro",
    "parameters": {
      "DUST": "polvere sahariana",
      "N": "nuvolosità totale in /8",
      "Nh": "nuvolosità alta in /8",
      "Nm": "nuvolosità media in /8",
      "Nl": "nuvolosità bassa in /8",
      "N-CU": "copertura con nubi cumuliformi in /8",
      "AUSL.T": "temperatura trigger",
      "SHW-IX": "Indice Showalter",
      "WX -CUF": "tempo significativo: NIL (nulla), RASH (pioggia), TS (temporale)",
      "RR": "precipitazioni totali [mm]",
      "RR-str": "precipitazioni stratiformi",
      "CONV": "precipitazioni convettive [mm]",
      "SN": "precipitazioni sotto forma di neve [mm]",
      "SN--RA": "limite delle nevicate [m]",
      "QAO ": "{{value}} hPa eq. vento medio, direzione e forza del vento, [°] e [m/s]",
      "QAN": "vento medio al suolo, direzione e forza, [°] e [m/s]",
      "QANmax": "vento max. (raffiche) al suolo [m/s]",
      "T ": "{{value}} hPa eq. temperatura [°C]",
      "T m": "temperatura a {{value}}m [°C]",
      "T 2m": "temperatura a 2m [°C]",
      "Tk 2m": "temperatura a 2m [°K]",
      "T GND": "temperatura al suolo",
      "Max-ADI": "temperatura massima di miscelazione [°C]",
      "Min Max": "temperatura min./max. nelle ultime 24h",
      "FROST": "limite dello zero termico [m]",
      "W cm": "500 hPa eq. vento verticale [cm/s]",
      "W --": "700 hPa eq. vento verticale [cm/s]",
      "W s": "{{value}} hPa eq. vento verticale [cm/s]",
      "H ": "{{value}} hPa quota geopotenziale [m]",
      "RF ": "{{value}} hPa eq. umidità relativa [%]"
    }
  },
  "awsome": {
    "Aggregation band": "Fascia altitudinale per profili aggregati",
    "Date": "Data",
    "Datetag": "Tag data",
    "Depth": "Profondità",
    "Dry instability": "Instabilità asciutta",
    "fair (<0.78)": "discreta (<0.78)",
    "fair (<1.05)": "discreta (>1.05)",
    "Grain type": "Tipologia grano",
    "LWC index": "Indice LWC",
    "New snow": "Neve fresca",
    "poor (<=3)": "scarso (<=3)",
    "poor (<0.95)": "scarso (<0.95)",
    "poor (>=0.78)": "scarso (>=0.78)",
    "Punstable": "P(unstable)",
    "rather stable (<0.7)": "piuttosto stabile (<0.7)",
    "rather stable (<1)": "piuttosto stabile (<1)",
    "rather stable (>1.05)": "piuttosto stabile (>1.05)",
    "Size estimate": "Stima della dimensione",
    "SK38 (RTA > 0.8)": "SK38 (RTA > 0.8)",
    "very poor (<=0.5)": "molto scarso (<=0.5)",
    "very poor (>=0.85)": "molto scarso (>=0.85)",
    "very poor (>3)": "molto scarso (>3)",
    "Wet instability": "Instabilità bagnata"
  },
  "channelStatus": {
    "loading": "Caricamento dello stato del canale...",
    "triggerStatusChecks": "Esegui i controlli dello stato"
  },
  "lineaexport": {
    "searchfieldplaceholder": "Cerca stazioni...",
    "hint": "Premi Invio per aggiungere"
  },
  "awsstats": {
    "title": "Statistiche servizi valanghe",
    "label": {
      "loading": "Caricare dati...",
      "startDate": "Seleziona data d'inizio",
      "endDate": "Seleziona data fine",
      "selectWeatherStation": "Seleziona stazione meteorologica",
      "selectMicroRegions": "Seleziona micro-zone",
      "clearselection": "Cancella selezione",
      "noMicroRegionsSelected": "nessuno/a",
      "last7days": "Ultimi sette giorni",
      "last30days": "Ultimi 30 giorni",
      "last90days": "Ultimi 90 giorni",
      "loadData": "Carica dati",
      "charttypes": "Tipo di diagramma"
    },
    "charts": {
      "aws-observations": "Osservazione servizi valanghe",
      "aws-danger-rating": "Grado pericolo valanghe",
      "aws-danger-rating-altitude": "Grado di pericolo a base di quota",
      "aws-avalanche-activity-index": "Indice attività valanghiva",
      "aws-danger-rating-danger-source-variants": "Variazioni dell'origine di pericolo",
      "aws-danger-source-variants-matrix-parameter-stability": "Stabilità delle variazioni dell'origine di pericolo",
      "aws-danger-source-variants-matrix-parameter-frequency": "Frequenza delle variazioni dell'origine di pericolo",
      "aws-danger-source-variants-matrix-parameter-avalanche-size": "Dimensioni delle valanghe associate alle varianti delle fonti di pericolo"
    },
    "error": {
      "startDateBeforeEndDate": "La data di inizio deve essere precedente o uguale alla data di fine.",
      "failedLoadData": "Impossibile caricare i dati per il periodo selezionato.",
      "startDateEndDateRequired": "È necessario specificare la data di inizio e quella di fine."
    }
  },
  "yearlystats": {
    "title": "Statistiche annuali",
    "label": {
      "startDate": "Data d'inizio",
      "endDate": "Data fine",
      "loaddata": "Carica dati",
      "last90Days": "Ultimi 90 giorni",
      "last180Days": "Ultimi 180 giorni",
      "currentSeason": "Stagione attuale",
      "regionCode": "Codice Provincia",
      "allRegions": "TUTTO",
      "virtualTrainings": "Formazione virtuale (date)",
      "fieldTrainings": "Formazione sul terreno (date)",
      "dangerRatingReference": "Dati di riferimento grado di pericolo"
    },
    "charts": {
      "aws-danger-rating-micro-regions-bars": "Valutazione grado di pericolo servizio valanghe - micro-zone - barre",
      "aws-danger-rating-micro-regions": "Valutazione grado di pericolo servizio valanghe - micro-zone",
      "aws-danger-rating-distribution": "Valutazione grado di pericolo servizio valanghe - distribuzione",
      "aws-danger-pattern-micro-regions": "Valutazione situazione tipo servizio valanghe - micro-zone",
      "aws-avalanche-problem-micro-regions": "Valutazione problemi valanghivi servizio valanghe - micro-zone",
      "aws-products": "Prodotti servizi valanghe",
      "aws-stress-level": "Livello di stress del team"
    },
    "hint": {
      "dangerRatingReference": "Valori di riferimento per la distribuzione dei gradi di pericolo nelle diverse stagioni, indicati in grigio",
      "dateChange": "Dopo aver modificato la data, è necessario premere il pulsante \"Carica dati\"."
    }
  },
  "zodForm": {
    "valid": "Valido",
    "required": "Campi obbligatori",
    "invalidNumber": "Inserire numero valido"
  }
}
